/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Modal from "../../Modal/Modal";
import Button from "../../Button";
import Styles from "./ProfilePictureModal.styles";
import { CommonStyles } from "../../Button/commonButtonStyle";
import { getInitials } from "../../../../pages/member/memberDetails/utlis";
import { AlertStatus } from "../../../../contants";
import { debounce } from "../../../../utils/helper";

function ProfilePictureModal({
  open,
  onClose,
  handleImageChange,
  handleImageUpload,
  memberProfile,
  isPhotoLoading,
  toast,
}) {
  const [selectedImage, setSelectedImage] = useState(null);
  console.log("23", isPhotoLoading);

  useEffect(() => {
    setSelectedImage(memberProfile.profilePhotoUrl);
  }, [memberProfile.profilePhotoUrl]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const maxSize = 800 * 1024;

    if (file && file.size > maxSize) {
      toast.show(
        "Selected image exceeds the maximum size of 800 KB",
        AlertStatus.ERROR
      );

      return;
    }

    setSelectedImage(URL.createObjectURL(file));
    handleImageChange(event);
  };

  return (
    <Box>
      <Modal open={open} onClose={onClose}>
        <Box>
          <Box style={Styles.topContainer}>
            <Typography style={Styles.title}>Add Profile Picture</Typography>
          </Box>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Box
              style={{
                ...Styles.imageView,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  overflow: "hidden",
                }}
              >
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Profile"
                    style={Styles.profileImage}
                    width="100"
                    height="100"
                  />
                ) : memberProfile.profilePhotoUrl ? (
                  <img
                    src={memberProfile.profilePhotoUrl}
                    alt="Profile"
                    style={Styles.profileImage}
                    width="100"
                    height="100"
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                      fontSize: "24px",
                    }}
                  >
                    {getInitials(memberProfile.fullName)}
                  </div>
                )}
              </div>
            </Box>
          </Box>

          {/* <Divider style={Styles.divider} /> */}
          <Box paddingTop="20px">
            <input
              type="file"
              onChange={handleFileChange}
              accept="image/png, image/jpeg"
              style={Styles.input}
            />
          </Box>
          <Typography variant="mini" color="#8C8C8C">
            Maximum upload file size: 800KB
          </Typography>

          <Box style={{ display: "flex", gap: 10 }}>
            <Button
              variant="contained"
              style={CommonStyles.buttonStyle}
              onClick={debounce(handleImageUpload)}
              // isLoading={isPhotoLoading}
              label="Submit"
              type="submit"
            />
            <Button
              variant="outlined"
              onClick={onClose}
              style={CommonStyles.buttonStyle}
              label="Cancel"
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default ProfilePictureModal;
